import PlayPauseMedia from 'js/components/PlayPauseMedia';

export default class Video {
  constructor(element) {
    this.element = element;

    if (this.video && this.button) {
      this.controls = new PlayPauseMedia(this.video, this.button);
    }
  }

  get video() {
    return this.element.querySelector('video');
  }

  get button() {
    return this.element.querySelector('button');
  }
}
